import { LOCATION_CHANGE } from "common/reducers/router.actions";
import { Record } from "immutable";
import { routerLocationFromJSON } from "common/records/RouterLocation";
import { RootActions, RootState } from ".";

export const RouterStateRecord = Record({
  location: routerLocationFromJSON({}),
  action: "",
});

export const initialState = RouterStateRecord();

export type RouterState = typeof initialState;

const model = "router";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case LOCATION_CHANGE: {
      state = state
        .setIn([model, "location"], routerLocationFromJSON(action.payload.location))
        .setIn([model, "action"], action.payload.action);

      return state;
    }

    default:
      return state;
  }
};
